export default async function wait(delayMS = 0): Promise<void> {
  await new Promise(resolve => setTimeout(resolve, delayMS));
}
